export enum MatchStatusEnum {
  ComingSoon = 'COMMING_SOON',
  SalesOpened = 'SALES_OPENED',
  SalesClosed = 'SALES_CLOSED',
  EarlySales = 'EARLY_SALES',
}
